import type { SVGProps } from 'react';

/**
 * `@genially/icons` has no eye, and the only place that needs one is the go-to-slide
 * button below, so it lives here rather than in a shared package.
 */
export const EyeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true" {...props}>
    <path
      fillRule="evenodd"
      d="M8 2.5C4.4 2.5 1.4 4.7 0 8c1.4 3.3 4.4 5.5 8 5.5s6.6-2.2 8-5.5c-1.4-3.3-4.4-5.5-8-5.5Zm0 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
    />
  </svg>
);
